import type { CancelToken } from 'axios'
import { PaginationT } from 'models/Pagination'
import { AxiosAction } from 'redux-axios-middleware'
import { Customer } from 'types/customer'
import { ResolvedAxiosAction } from 'utilities/types'

export const GET_SAMPLE_CUSTOMERS = 'sampleCustomers/GET_SAMPLE_CUSTOMERS'
export const GET_SAMPLE_CUSTOMERS_SUCCESS =
  'sampleCustomers/GET_SAMPLE_CUSTOMERS_SUCCESS'
export const GET_SAMPLE_CUSTOMERS_FAIL =
  'sampleCustomers/GET_SAMPLE_CUSTOMERS_FAIL'

export type GetSampleCustomersAction = AxiosAction<
  typeof GET_SAMPLE_CUSTOMERS,
  {
    sample_customers: Customer[]
    customer_count: number
    pagination: PaginationT
  }
>

export type ResolvedAction = ResolvedAxiosAction<
  ReturnType<typeof getSampleCustomers>
>

export type SampleCustomersResolvedAction = {
  type: typeof GET_SAMPLE_CUSTOMERS_SUCCESS
  payload: {
    data: {
      sample_customers: Customer[]
      customer_count: number
      pagination: PaginationT
    }
  }
  meta: {
    previousAction: GetSampleCustomersAction
  }
}

export function getSampleCustomers(
  segmentId: string,
  params?: { page?: number; per_page?: number; cancelToken?: CancelToken }
): GetSampleCustomersAction {
  return {
    type: GET_SAMPLE_CUSTOMERS,
    payload: {
      client: 'default',
      request: {
        url: `target_segments/${segmentId}/sample_customers`,
        method: 'get',
        params: {
          page: params?.page || 1,
          per_page: params?.per_page || 10,
        },
        cancelToken: params?.cancelToken,
      },
    },
  }
}
